/**
 * Detects if the browser reliably supports window.print()
 * Print functionality is known to be unreliable on iOS and some mobile browsers
 */
export const isPrintSupported = (): boolean => {
  // Check if we're in a browser environment
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent || navigator.vendor || '';

  // Detect iOS devices (iPhone, iPad, iPod)
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;

  // Detect Android mobile browsers (exclude tablets)
  const isAndroidMobile = /Android/.test(userAgent) && /Mobile/.test(userAgent);

  // Detect other mobile browsers
  const isMobile = /Mobi|Android/i.test(userAgent);

  // Print is unreliable on iOS and most mobile browsers
  // Only allow on desktop browsers
  return !isIOS && !isAndroidMobile && !isMobile;
};
